import { render, staticRenderFns } from "./CA-SL-Disclosure.vue?vue&type=template&id=045f08ae&scoped=true&"
import script from "./CA-SL-Disclosure.vue?vue&type=script&lang=js&"
export * from "./CA-SL-Disclosure.vue?vue&type=script&lang=js&"
import style0 from "./CA-SL-Disclosure.vue?vue&type=style&index=0&id=045f08ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045f08ae",
  null
  
)

export default component.exports